import { useCallback } from 'react';
import { FormFieldsData, ModalForm, NumberInput } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import { useNewProjectService } from 'domain/shared/newProject';
import { ProjectManagementHealthcheckModalProps } from './types';

const ProgressUpdateModal = ({
  data,
  isOpen,
  onClose,
  refetchControlsData,
}: ProjectManagementHealthcheckModalProps) => {
  const { putProjectProgressForecast, progressValidationSchema } = useNewProjectService();

  const submitFormFunc = useCallback(
    async (stateData: FormFieldsData) => {
      const updatedForecastData = {
        plannedProgress: stateData.forecast?.plannedProgress,
        actualProgress: stateData.forecast?.actualProgress,
      };
      return putProjectProgressForecast(data.id, updatedForecastData);
    },
    [putProjectProgressForecast, data.id],
  );

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Progress">
      <ModalForm
        closeModal={onClose}
        modalOpen={isOpen}
        submitFormFunc={submitFormFunc}
        getValidationSchemaFunc={progressValidationSchema}
        afterSubmit={{ execute: () => refetchControlsData() }}
        getDataFunc={async () => data}
      >
        <NumberInput
          source="forecast.plannedProgress"
          label="Planned Progress (%)"
          slotProps={{ htmlInput: { min: 0, step: 25 } }}
        />
        <NumberInput
          source="forecast.actualProgress"
          label="Actual Progress (%)"
          slotProps={{ htmlInput: { min: 0, step: 25 } }}
        />
      </ModalForm>
    </Modal>
  );
};

export default ProgressUpdateModal;
